import React, { useContext } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import { AccountContext } from 'contexts/AccountContext'
import Navbar from 'components/Navbar'

const DRAWER_WIDTH = 240

const PrivateRoutes = () => {
  const { isAuthenticated } = useContext(AccountContext)

  if (!isAuthenticated) {
    return <Navigate to='/login' replace />
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Navbar />
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          width: `calc(100% - ${DRAWER_WIDTH}px)`,
          minHeight: '100vh',
          bgcolor: 'background.default'
        }}
      >
        <Outlet />
      </Box>
    </Box>
  )
}

export default PrivateRoutes
